export enum BingoMatchStatus {
	Ongoing = 'ongoing',
	Settled = 'settled',
}
